<template>
  <div class="layout-print">
    <payments-list for-print />
  </div>
</template>

<script>
import PaymentsList from 'Components/Affiliates/PaymentsList'

export default {
  name: 'PrintPaymentsList',
  components: { PaymentsList },
  methods: {
    print () {
      this.$nextTick(() => {
        this.$vuetify.theme.dark = false
        setTimeout(() => {
          window.print() // open browser's print dialog
        }, 200)
      })
    }
  },
  mounted () {
    this.print()
  },
}
</script>

<style>
@media print {
  /* Fix for colour printing */
  * {
    color: inherit !important;
  }
}
.layout-print {
  background-color: white;
}
</style>
